import { Palette, Theme } from "@mui/material";

export const theme = (
  func: (theme: Theme) => string | number
): ((props: any) => string | number) => {
  return (props) => func(props.theme);
};

export const spacing = (spacing: number): ((props: any) => string) => {
  return (props) => props.theme.spacing(spacing);
};

export const palette = (
  func: (palette: Palette) => string
): ((props: any) => string) => {
  return (props) => func(props.theme.palette);
};
